export default __webpack_public_path__ + "static/media/inspector-text-align-center.19ad3b6d.svg";